/* PG Joint Content
   DESTINATION: assets/pg-joint-content.js
   Accordions (ingredients + FAQ), show-more reveal, animated stat rings. */
(function () {
  'use strict';

  var RING_CIRCUMFERENCE = 326.7; // 2 * PI * r where r = 52

  function init(root) {
    if (!root || root.__pgcReady) return;
    root.__pgcReady = true;

    /* ---- Accordions ---- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-pgc-toggle]'), function (btn) {
      var panel = btn.nextElementSibling;
      if (!panel) return;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.classList.toggle('is-open', !open);
      });
    });

    /* First ingredient in each group opens by default */
    Array.prototype.forEach.call(root.querySelectorAll('[data-pgc-group="ingredient"]'), function (group) {
      var first = group.querySelector('.pgc-ing [data-pgc-toggle]');
      if (!first) return;
      first.setAttribute('aria-expanded', 'true');
      if (first.nextElementSibling) first.nextElementSibling.classList.add('is-open');
    });

    /* ---- Show more ingredients ---- */
    Array.prototype.forEach.call(root.querySelectorAll('[data-pgc-more]'), function (btn) {
      btn.addEventListener('click', function () {
        var hidden = root.querySelectorAll('.pgc-ing.is-hidden');
        if (!hidden.length) return;
        Array.prototype.forEach.call(hidden, function (el) {
          el.classList.remove('is-hidden');
        });
        btn.setAttribute('hidden', 'hidden');
        btn.style.display = 'none';
      });

      /* Nothing left to reveal -> hide the button up front */
      if (!root.querySelector('.pgc-ing.is-hidden')) {
        btn.setAttribute('hidden', 'hidden');
        btn.style.display = 'none';
      }
    });

    /* ---- Stat rings ---- */
    var statGroups = root.querySelectorAll('[data-pgc-stats]');
    if (statGroups.length) {
      var fill = function (group) {
        Array.prototype.forEach.call(group.querySelectorAll('[data-pgc-ring]'), function (circle) {
          var pct = Math.max(0, Math.min(100, Number(circle.dataset.pgcRing) || 0));
          var offset = RING_CIRCUMFERENCE * (1 - pct / 100);
          circle.style.strokeDashoffset = String(offset);
        });
      };

      if (typeof IntersectionObserver === 'function') {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                fill(entry.target);
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.3 }
        );
        Array.prototype.forEach.call(statGroups, function (g) {
          io.observe(g);
        });
      } else {
        Array.prototype.forEach.call(statGroups, fill);
      }
    }

    /* ---- Marquee: only animate when there is overflow ---- */
    Array.prototype.forEach.call(root.querySelectorAll('.pgc-marquee'), function (m) {
      var track = m.querySelector('.pgc-marquee__track');
      if (track && track.scrollWidth <= m.clientWidth) {
        track.style.animation = 'none';
        track.style.justifyContent = 'center';
        track.style.width = '100%';
      }
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pgc-root]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pgc-root]');
    if (root) init(root);
  });
})();